import React, { Component } from "react";

import { Tooltip, TooltipProvider, TooltipWrapper } from 'react-tooltip';
import { Box, Flex, Spacer, HStack, Card, CardBody, Text, SimpleGrid, Button } from '@chakra-ui/react';

import { AgGridReact } from "ag-grid-react";
// import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt, faRedoAlt, faRecycle } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from 'react-tooltip';

import CoreService from "../../../services/CoreService";
import { throwStatement } from "@babel/types";
import LookupEntityManager from "../../Observation/Components/Managers/LookupEntityManager";

const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";

const columnDefs =
    [
        {headerName: "Lookup Key", field: "entityKey", sortable: true, filter: true, resizable: true, minWidth: 75 },
        {headerName: "Type", field: "description", sortable: true, filter: true, resizable: true, minWidth: 75,  wrapText: true, autoHeight: true},
        {headerName: "Schema", field: "schemaId", sortable: true, filter: true, resizable: true, minWidth: 75,  wrapText: true, autoHeight: true},      
        {headerName: "Identifier", field: "identifier", sortable: true, filter: true, resizable: true, minWidth: 250,  wrapText: true, autoHeight: true},
        {headerName: "Last Updated", field: "lastUpdated", sortable: true, filter: true, resizable: true, minWidth: 200},
        {headerName: "Last Updated By", field: "lastUpdatedBy", sortable: true, filter: true, resizable: true, minWidth: 200},
  
    ];


export default class ListDetailGrid extends Component {
    constructor(props) {
        super(props);
        this.coreService = new CoreService();
        this.state = {
            gridData: [],
            isLoading: true
        }
        this.requestGridDataRefresh = this.requestGridDataRefresh.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.onRowDoubleClicked = this.onRowDoubleClicked.bind(this);
    }

    async componentDidMount() {
        this.setState({
            gridData: this.props.subList
        })
    }


    onSelectionChanged() {
        console.log("Changing selected row")
        var selectedNodes = this.gridApi.getSelectedNodes();
        var rowData = selectedNodes[0].data;
        //var rowNode = selectedNodes[0];
        console.info(rowData);
        this.props.onRowSelectChange(rowData); 
      }
    
      onRowDoubleClicked(row){
        console.group("On Row Double Clicked Row: ");
        console.log(row.data);
        console.groupEnd();
        var rowData = row.data;
        this.props.onRowSelectChange(rowData);
      }

    onEditGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.resetRowHeights();
        this.gridApi.sizeColumnsToFit();
    };

    async requestGridDataRefresh(e) {
        // await this.refreshGridData();
        this.props.onToastRequest("information", "List Data Refreshed");
    }





    render() {

        const divStyle = {
            width: "100%",
            height: "40vh"

        };

        const gridOptions = {
            onRowDoubleClicked: this.onRowDoubleClicked
          }

        // const gridData = (this.props.subList) ? this.state.gridData : [{}];
        // const loadingIcon = this.state.isLoading ? (
        //     <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
        // ) : (
        //     ""
        // );
        const listName = (this.props.currentList) ? this.props.currentList.description : "";

        return (

            <Box>
                <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>{listName}</Text>


                {/*
                <Button
                    onClick={(e) => this.requestGridDataRefresh(e)}
                    leftIcon={<FontAwesomeIcon icon={faRecycle} />}
                    bg='#0095c8'
                    color='white'
                    fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                    margin='10px'
                >
                    Refresh
                </Button>
        */}

                {/* {loadingIcon} */}


                <div className="ag-theme-balham" style={divStyle}>
                    <AgGridReact
                        rowSelection="single"
                        enableRangeSelection={false}
                        pagination={true}
                        columnDefs={columnDefs}
                        rowData={this.props.subList}
                        animateRows={true}
                        onGridReady={this.onGridReady}

                        onSelectionChanged={this.onSelectionChanged.bind(this)}
                        gridOptions = {gridOptions}
                        domLayout="autoHeight"
                        onRowDoubleClicked = {this.props.onEditRequest}

                    //onSelectionChanged={this.onSelectionChanged.bind(this)}
                    />
                </div>

            </Box>

        );
    }
}